export enum ScenarioName {
  AppLaunch = "applaunch",
  StartVirtualVisit = "startvirtualvisit",
  SendVisitLink = "sendvisitlink",
  CopyVisitLink = "cpoyvisitlink",
}

export enum ScenarioType {
  VirtualVisitAppointment = "virtualvisitappointment",
}

export enum PanelType {
  ConnectedAppointmentView = "connectedappointmentview",
  GlobalError = "globalerror",
  AppLaunch = "applaunch",
  AppLaunchContinue = "applaunchcontinue",
  AppLaunchAadContinue = "applaunchaadcontinue",
}

export enum ModuleName {
  StartVirtualVisitButton = "Start Virtual Visit button",
  SendVisitLink = "Send Visit Link",
  CopyVisitLink = "Copy Visit Link",
}

export enum ModuleSummary {
  StartVirtualVisitButton = "Start Virtual Visit button click event.",
  SendVisitLink = "Send Visit Link click event.",
  CopyVisitLink = "Copy Visit Link click event",
}

export enum RequestResult {
  Error = "error",
  NetworkError = "networkError",
}

export enum DataBagHttpColumns {
  // PascalCase to match Virtual Visits column name.
  DataBagCorrelationId = "DataBag.CorrelationId",
  DataBagErrorType = "DataBag.errorType",
  DataBagIsRetry = "DataBag.isRetry",
  DataBagIsSuccessful = "DataBag.isSuccessful",
  DataBagReason = "DataBag.reason",
  DataBagServiceUrl = "DataBag.serviceUrl",
  DataBagUrl = "DataBag.url",
  DatabBagErrorSubType = "DataBag.errorSubType",
}

export enum EventType {
  NonUiEvent = "nonuievent",
}
